import { WebUrlSegments } from "@ms/uno-constants/lib/local/WebConstants";
/**
 * The query parameters used by SW
 */ export var SWQueryParams = /*#__PURE__*/ function(SWQueryParams) {
    /** Client build version */ SWQueryParams["BuildVersion"] = "buildVersion";
    /** Canonical Id of the current user */ SWQueryParams["UserId"] = "userObjectId";
    /** Canonical Id of the signed in tenant */ SWQueryParams["TenantId"] = "tid";
    /** Client type to load planner */ SWQueryParams["ClientType"] = "clientType";
    /**
     * Id of the host ring (used in build rollout) which the user is currently (could be client ring override).
     * For example, in Teams this is the user's Teams ringId/audienceGroup
     * Undefined when not supported by service/host */ SWQueryParams["RingId"] = "ringId";
    /** Current user's locale preference */ SWQueryParams["Locale"] = "locale";
    /** If the user is a guest user */ SWQueryParams["IsGuestUser"] = "isGuestUser";
    /** Platform of the app */ SWQueryParams["Platform"] = "platform";
    /** User's UPN (User Principal Name) */ SWQueryParams["UserUpn"] = "userUpn";
    /** User's display name */ SWQueryParams["DisplayName"] = "displayName";
    return SWQueryParams;
}({});
/** trigger reason to unregister service worker */ export var ServiceWorkerUnregistrationTrigger = /*#__PURE__*/ function(ServiceWorkerUnregistrationTrigger) {
    ServiceWorkerUnregistrationTrigger["DisableServiceWorkersSettingEnabled"] = "DisableServiceWorkersSettingEnabled";
    ServiceWorkerUnregistrationTrigger["InstallationStalled"] = "InstallationStalled";
    ServiceWorkerUnregistrationTrigger["ScriptTagLoadError"] = "ScriptTagLoadError";
    ServiceWorkerUnregistrationTrigger["GlobalRouteCatchHandler"] = "GlobalRouteCatchHandler";
    ServiceWorkerUnregistrationTrigger["QuotaExceeded"] = "QuotaExceeded";
    return ServiceWorkerUnregistrationTrigger;
}({});
/** Legacy MTRS service worker script path */ export const LegacyMtrsServiceWorkerPath = "/service-worker.js";
/** Planner Service Teams service worker script path */ export const PlannerServiceTeamsServiceWorkerPath = "/ui/service-worker.js";
/** Resource types for service worker requests */ export var RequestResourceType = /*#__PURE__*/ function(RequestResourceType) {
    RequestResourceType["Document"] = "document";
    RequestResourceType["Iframe"] = "iframe";
    RequestResourceType["Script"] = "script";
    RequestResourceType["Image"] = "image";
    RequestResourceType["Font"] = "font";
    RequestResourceType["Other"] = "other";
    return RequestResourceType;
}({});
/** Maximum retry attempts for HTML requests */ export const HTML_RETRY_MAX_ATTEMPTS = 2;
/**
 * List of bundles to precache
 */ export const bundlesToPrecache = [
    "app",
    "boot-critical-fluentui",
    "boot-critical-appstrings",
    "prefetcher",
    "runtime",
    "planner-leftnav",
    "planner-mytaskspage",
    "planner-planpage",
    "planner-plantasksboardview"
];
/**
 * Regex pattern for matching precache bundle files
 */ export const precacheRegexPattern = `^.*\\/(${bundlesToPrecache.join("|")})\\.[a-f0-9]{10}\\.(?:chunk|bundle)\\.js$`;
const plannerWebPathRegexPattern = `(?:${WebUrlSegments.WebUI}|${WebUrlSegments.PlannerServiceWebPathSegment})`;
/**
 * Regex for matching HTML pages that should be cached
 */ // Safe: plannerWebPathRegexPattern is composed only from static WebUrlSegments enum members.
// eslint-disable-next-line security/detect-non-literal-regexp
export const htmlpagesRegex = new RegExp(`/(?:teamsui|ui/teams)/[0-9a-fA-F_\\.-]{16,}/Home/PlannerFrame\\?.*page=(?:7|8)|/(?:teamsui|ui/teams)/messageTasks|planner\\.cloud\\.microsoft/${plannerWebPathRegexPattern}\\b.*[?&]userObjectId=`);
/**
 * Regex for matching JS, image, and font assets that should be cached
 */ export const jsImageFontAssetsRegex = /.*(?:\/js\/[a-zA-Z0-9-]+\.[a-f0-9]{10}\.(?:bundle|chunk)\.js|\/assets\/.*\.(?:png|jpg|jpeg|svg|woff))$/i;
/**
 * These regex are subset of htmlpagesRegex and are required to get the clientFlavor
 */ export const mainAppHtmlPagesRegex = /\/(?:teamsui|ui\/teams)\/[0-9a-fA-F_\.-]{16,}\/Home\/PlannerFrame\?.*page=8/i;
export const channelTabHtmlpagesRegex = /\/(?:teamsui|ui\/teams)\/[0-9a-fA-F_\.-]{16,}\/Home\/PlannerFrame\?.*page=7/i;
export const messageTasksHtmlPagesRegex = /\/(?:teamsui|ui\/teams)\/messageTasks/i;
// Safe: plannerWebPathRegexPattern is composed only from static WebUrlSegments enum members.
// eslint-disable-next-line security/detect-non-literal-regexp
export const webHtmlPagesRegex = new RegExp(`planner\\.cloud\\.microsoft/${plannerWebPathRegexPattern}\\b.*[?&]userObjectId=`);
export const logPrefix = "[EvoServiceWorker]";
